// @flow
import React from 'react';
import injectSheet from 'react-jss';
import { A } from '~/app/ui/tokens';

type Props = {
  arrowPosition: 'top' | 'bottom' | 'right' | 'left',
  classes: Object,
  children: Node,
  containerStyle: Object
};

function DialogModal({ classes: c, arrowPosition, containerStyle, children }: Props) {
  const arrowStyle = () => {
    switch (arrowPosition) {
      case 'bottom':
        return {
          borderTopColor: A.surface,
          margin: '300px 0 0 130px'
        };
      case 'left':
        return {
          borderRightColor: A.surface,
          margin: '80px 0px 0px -260px'
        };
      case 'right':
        return {
          borderLeftColor: A.surface,
          margin: '80px 0px 0px 260px'
        };
      default:
        return {
          borderBottomColor: A.surface,
          margin: '-20px 0px 0px 130px'
        };
    }
  };

  return (
    <div className={c.container} style={containerStyle}>
      <div className={c.body}>
        {children}
      </div>
      <div className={c.arrow} style={arrowStyle()} />
    </div>
  );
}

const styles = {
  container: {
    position: 'relative',
    boxShadow: '-1px 11px 31px 1px rgba(0,0,0,0.35)',
    backgroundColor: A.surface
  },
  arrow: {
    border: 'solid 10px transparent',
    position: 'absolute'
  },
  body: {
    display: 'flex',
    flexGrow: '2'
  }
};

export default injectSheet(styles)(DialogModal);
